import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
} from '@mui/material';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';

const SubscriptionCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: '#F8F8F8', minHeight: '100vh', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="sm">
        <Card sx={{ borderRadius: 4, p: { xs: 3, md: 4 } }}>
          <CardContent>
            <Stack spacing={3} alignItems="center">
              <ReplayCircleFilledIcon color="action" sx={{ fontSize: 64 }} />
              <Typography variant="h4" fontWeight={800} align="center">
                Platba nebyla dokončena
              </Typography>
              <Typography variant="body1" color="text.secondary" align="center">
                Vrátili jste se ze Stripe platební brány. Pokud chcete předplatné aktivovat,
                můžete to zkusit znovu – platební údaje se nebojte, vše probíhá zabezpečeně.
              </Typography>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => navigate('/pricing')}
                >
                  Zkusit znovu
                </Button>
                <Button variant="outlined" onClick={() => navigate('/dashboard')}>
                  Zpět do aplikace
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default SubscriptionCancelPage;
